export const getArgentinaFormat = (hourDate?: boolean) => {
  const ahora = new Date();

  let opciones: any = {
    timeZone: "America/Argentina/Buenos_Aires",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  if (hourDate)
    opciones = {
      ...opciones,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };

  const formato = new Intl.DateTimeFormat("sv-SE", opciones); // Usa 'sv-SE' para el formato YYYY-MM-DD
  const fechaFormateada = formato.format(ahora);

  return fechaFormateada;
};

export const getFormattedDate = (timestamp: any) => {
  if (!timestamp) return "No date";

  // 1. Convert Firestore Timestamp to a JavaScript Date object
  const date = timestamp.toDate();

  // 2. Format the date for the user's local timezone
  // This will automatically adjust for the user's system timezone
  const formattedDate = date.toLocaleString("es-AR", {
    hour: "2-digit",
    minute: "2-digit",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  return formattedDate;
};
